
import React from 'react';
import styles from './ExpandedContentModal.module.css';

interface ExpandedContentModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
  readOnly?: boolean;
  onSave?: (newContent: string) => void;
  placeholder?: string;
}

const ExpandedContentModal: React.FC<ExpandedContentModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  readOnly = false,
  onSave,
  placeholder = 'Enter text here...',
}) => {
  const [localContent, setLocalContent] = React.useState(content);

  // Sync local state when content prop changes or modal opens
  React.useEffect(() => {
    if (isOpen) {
      setLocalContent(content);
    }
  }, [content, isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (onSave) {
      onSave(localContent);
    }
    onClose();
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
          <button className={styles.close} onClick={onClose} data-testid="expanded-modal-close">
            ×
          </button>
        </div>
        <div className={styles.content}>
          {readOnly ? (
            <div className={styles.readOnlyContent}>
              {localContent ? localContent.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              )) : <span className={styles.emptyText}>No description available.</span>}
            </div>
          ) : (
            <textarea
              className={styles.textarea}
              value={localContent}
              onChange={(e) => setLocalContent(e.target.value)}
              placeholder={placeholder}
              autoFocus
            />
          )}
        </div>
        {!readOnly && (
          <div className={styles.footer}>
            <button className={styles.buttonSecondary} onClick={onClose}>
              Cancel
            </button>
            <button className={styles.buttonPrimary} onClick={handleSave}>
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpandedContentModal;
